import { Check, X } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * A removable chip showing an active filter value.
 */
export function ActiveFilterChip({ label, onRemove }: { label: string; onRemove: () => void }) {
	return (
		<span className="inline-flex items-center gap-1 rounded-[var(--r-1)] border border-line-2 bg-surface py-0.5 pr-1 pl-2.5 text-sm text-text-2">
			{label}
			<button
				onClick={onRemove}
				className="flex h-4 w-4 cursor-pointer items-center justify-center rounded-[var(--r-1)] bg-transparent text-text-3 hover:text-text-1"
			>
				<X size={11} />
			</button>
		</span>
	);
}

/**
 * A toggleable filter chip used inside filter panels.
 */
export function FilterChip({
	active,
	onClick,
	children,
}: {
	active: boolean;
	onClick: () => void;
	children: React.ReactNode;
}) {
	return (
		<button
			onClick={onClick}
			className={cn(
				'inline-flex h-6 cursor-pointer items-center gap-1 rounded-[var(--r-1)] border px-2.5 text-sm transition-all duration-75',
				active
					? 'border-accent bg-accent-soft text-accent'
					: 'border-line-2 bg-transparent text-text-2 hover:border-line-3'
			)}
		>
			{active && <Check size={11} />}
			{children}
		</button>
	);
}

/**
 * A labeled group of filter chips.
 */
export function FilterGroup({ label, children }: { label: string; children: React.ReactNode }) {
	return (
		<div className="mb-3">
			<div className="mb-1.5 text-xs font-medium uppercase tracking-[0.06em] text-text-3">
				{label}
			</div>
			<div className="flex flex-wrap gap-1.5">{children}</div>
		</div>
	);
}
